var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktokLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.822.815c0 .333.032.659.092.975a5.358 5.358 0 0 0 2.391 3.508l.002.002a5.499 5.499 0 0 0 2.968.865v3.846a9.442 9.442 0 0 1-5.453-1.72v7.814c0 3.904-3.237 7.08-7.216 7.08A7.265 7.265 0 0 1 5.472 21.9c-1.86-1.281-3.08-3.4-3.08-5.795 0-3.903 3.236-7.079 7.214-7.079.33 0 .654.027.973.07v3.925a3.33 3.33 0 0 0-.973-.15c-1.817 0-3.295 1.452-3.295 3.234 0 1.242.717 2.32 1.766 2.862v.001c.457.235.978.372 1.53.372 1.774 0 3.222-1.385 3.288-3.111L12.901.815h3.92Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokLine);
export default __webpack_public_path__ + "static/media/tiktok_line.7cee8191be61d470537091f212d33ed1.svg";
export { ForwardRef as ReactComponent };